import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Avatar from '@mui/material/Avatar';
import colors from 'styles/colors';
import usePermissions from 'hooks/usePermissions';
import { splitName } from 'utils/helpers';
import TeamSettingsRowActionMenu from './TeamSettingsRowActionMenu';
import getColorForName from '../../../utils/nameColorPicker';

const TeamSettingsRow = ({ member, columns, updateTeamMembers }) => {
  const { hasPermission } = usePermissions();
  const { firstName, lastName } = splitName(member.displayName);

  return (
    <TableRow
      key={member.id}
      sx={{
        '&:last-child th': { border: 0 },
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: `${colors.background.secondary}`,
        },
      }}
    >
      {
        columns.map(({ key }) => {
          if (key === 'displayName') {
            return (
              <TableCell key={key} align="left">
                <div
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
                >
                  <Avatar
                    alt={member.displayName}
                    src={member.avatar}
                    style={{
                      marginRight: '10px',
                      fontSize: '14px',
                      backgroundColor: getColorForName(firstName, lastName),
                      width: '32px',
                      height: '32px',
                      textTransform: 'capitalize',
                    }}
                  >
                    {member.displayName[0]}
                  </Avatar>
                  {member.displayName}
                </div>
              </TableCell>
            );
          }

          return (
            <TableCell key={key} align="left">{member[key]}</TableCell>
          );
        })
      }
      <TableCell align="right">
        {hasPermission('team.member.remove') && (
          <TeamSettingsRowActionMenu
            updateTeamMembers={updateTeamMembers}
            id={member.userId}
            name={member.displayName}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default TeamSettingsRow;
